export default __webpack_public_path__ + "static/media/sd-banner-2.d8939803.jpg";